import { Injectable } from '@angular/core';
import { ImportCustomListsNetworkingService } from './import-custom-lists-networking.service';
import { catchError, map, Observable, of } from 'rxjs';
import { CustomListItem } from '../types/import-custom-list.types';

@Injectable()
export class CustomListDataService {
  constructor(
    private readonly networkService: ImportCustomListsNetworkingService
  ) {}

  public fetchCustomLists(profile?: string): Observable<CustomListItem[]> {
    return this.networkService
      .getCustomLists(profile)
      .pipe(map((lists) => lists.filter((list) => !!list.listName)));
  }

  public importCustomLists(
    customListIds: string[],
    profile?: string
  ): Observable<boolean> {
    return this.networkService.importCustomLists(customListIds, profile).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }
}
